export function getMetaValue(name) {
    const element = document.querySelector(`meta[name="${name}"]`)
    return element?.getAttribute("content")
}